<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :data="tableData"
      :height="tableHeight"
      :loading="loading"
      :toolbar-config="tableToolbar"
      :columns="tableColumns"
      size="small"
      resizable
      border
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <b-button
            size="sm"
            :disabled="isEdit"
            variant="outline-success"
            @click="
              openEditFormDialog({
                type: 'add',
                carrierCode: code,
              })
            "
            ><b-icon-plus></b-icon-plus>添加
          </b-button>
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditFormDialog({
                  type: 'detail',
                  carrierCostItemCode: row.carrierCostItemCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="编辑" placement="top">
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditFormDialog({
                  type: 'edit',
                  carrierCostItemCode: row.carrierCostItemCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="删除" placement="top">
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.carrierCostItemCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>

      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>

    <el-dialog
      v-if="editFormDialogOptions.visible"
      v-el-dialog-drag
      show-close
      visible
      width="700px"
      :title="editFormDialogOptions.title"
      :close-on-click-modal="false"
      :before-close="() => $refs.editForm.cancel()"
    >
      <edit-form
        ref="editForm"
        :disabled="editFormDialogOptions.disabled"
        :carrierCostItemCode="editFormDialogOptions.carrierCostItemCode"
        :carrierCode="code"
        @reload="getData"
        @close="closeEditFormDialog"
      />
      <span slot="footer">
        <el-button size="small" @click="$refs.editForm.cancel()"
          >取消</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click="$refs.editForm.save()"
          v-if="!editFormDialogOptions.disabled"
          >保存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import editForm from './edit-form'
import tableColumns from './cost-itme-table-columns'
export default {
  components: { editForm },
  props: {
    isEdit: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
    },
  },
  data() {
    return {
      loading: false,
      tableHeight: 600,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(),
      tableData: [],
      editFormDialogOptions: {
        visible: false,
        carrierCostItemCode: '',
        carrierCode: '',
      },
    }
  },
  computed: {
    pageType() {
      return this.$route.params.pageType
    },
    isDisable() {
      return this.pageType === 'detail'
    },
  },
  mounted() {
    this.getData()
  },
  created() {
    window.addEventListener('resize', this.getHeight)
    this.getHeight()
  },
  destroyed() {
    window.removeEventListener('resize', this.getHeight)
  },
  methods: {
    getHeight() {
      this.tableHeight = window.innerHeight - 204
    },
    getData() {
      if (!this.code) return
      this.$api
        .masterCarrierCostItemListApi({
          carrierCode: this.code,
        })
        .then((res) => {
          this.tableData = res.body.data
        })
    },
    del(code) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api
          .masterCarrierCostItemDelApi({ carrierCostItemCode: code })
          .then((res) => {
            this.$message({
              showClose: true,
              message: res.msg,
              type: 'success',
            })
            this.getData()
          })
      })
    },
    openEditFormDialog({
      type = '',
      carrierCostItemCode = '',
      carrierCode = '',
    }) {
      const types = {
        edit: '编辑费用信息',
        add: '添加费用信息',
        detail: '客户费用信息详情',
      }
      this.editFormDialogOptions = {
        visible: true,
        title: types[type],
        carrierCostItemCode,
        carrierCode,
        disabled: type === 'detail',
      }
    },
    closeEditFormDialog() {
      this.editFormDialogOptions.visible = false
    },
  },
}
</script>
